import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { consentGoogleAnalytics } from "@/helpers/analytics.helper";
import { onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonCookiesManager',
  setup(__props) {

const preferences = [
    {
        title: "Fonctionnalités essentielles",
        description: "Sans ces fonctionnalités essentielles, nous pourrions ne pas être en mesure de vous permettre d’accéder à notre site web ou application et de vous fournir nos services de façon optimale. Il s’agit par exemple de la conservation vos choix concernant le dépôt de cookies. Cette finalité est requise par notre site pour fonctionner normalement et ne peut pas être désactivée.",
        items: [{
            label: "Active",
            value: "essential",
            isRequired: true
        }],
    },
    {
        title: "Statistiques",
        description: "Ces cookies nous permettent de mesurer le trafic et l’activité des visiteurs sur notre site, afin d’en améliorer le fonctionnement et de comprendre comment les visiteurs interagissent avec notre site. Les informations collectées sont anonymes et agrégées.",
        items: [{
            label: "Google Analytics",
            value: "ga",
            isEnable: true,
        }],
    }
];

onMounted(() => {
    if(localStorage.getItem("cookie-comply") == null) {
        return;
    }
    if(localStorage.getItem("cookie-comply") == 'all' || localStorage.getItem("cookie-comply")?.match(/ga/)) {
        consentGoogleAnalytics();
    }
});

const onAcceptAll = () => {
    consentGoogleAnalytics();
};

const onSavePreferences = (preferences: string[]) => {
    if(preferences.includes("ga")) {
        consentGoogleAnalytics();
    }
};

return (_ctx: any,_cache: any) => {
  const _component_vue_cookie_comply = _resolveComponent("vue-cookie-comply")!

  return (_openBlock(), _createBlock(_component_vue_cookie_comply, {
    preferences: preferences,
    acceptAllLabel: "Autoriser",
    preferencesLabel: "Paramétrer",
    onOnAcceptAllCookies: onAcceptAll,
    onOnSaveCookiePreferences: onSavePreferences
  }, {
    header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("header", null, [
        _createElementVNode("h3", null, "Cookies"),
        _createElementVNode("p", null, [
          _createTextVNode("Nous utilisons de cookies pour le bon fonctionnement su site et pour récolter des statistiques d'utilisation."),
          _createElementVNode("br"),
          _createTextVNode("Vous pouvez paramétrer les cookies que vous souhaitez activer en cliquant sur le bouton Paramétrer.")
        ])
      ], -1)
    ]))]),
    "modal-header": _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createElementVNode("h3", null, "Paramètres de cookies", -1)
    ]))]),
    _: 1
  }))
}
}

})